import {
  createPublishCompletedEvent,
  createPublishFailedEvent,
  createPowtoonCreatedEvent,
  createPowtoonDeletedEvent,
  createServerNotificationEvent,
  createLicenseUpdatedEvent,
  createPowtoonUpdatedEvent,
  createPPTXReadyEvent,
  createPPTXFailedEvent,
  createPowtoonRecordingVideoEventUpdatedEvent,
  folderEvent, folderItemsChangedEvent,
  createConsumedExportEvent,
  createContentVideoUrlCreatedEvent,
  createClassChangedEvent,
  createSubmissionChangedEvent,
  userAssetUpdatedEvent,
  createPowtoonAccessEvent,
  createPowtoonAccessUpdated,
  createCompanyTemplateUpdatedEvent, createPowtoonContentUpdatedEvent,
  createBalanceUpdatedEvent,
  createSessionExpiredEvent
} from 'powtoon-commons/events/PowtoonEvent'
import {PusherEventConverter} from './types'
import {IPowtoonEvent} from 'powtoon-commons/events/types'


const createStandardPowtoonEventsConverter = (
  cb: (eventData: any) => IPowtoonEvent, comparator: string
) => (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' &&
    pusherEventData.name === 'powtoon-events' && pusherEventData.data?.type === comparator) {
    return cb(pusherEventData.data)
  }
}

export const PowtoonCreatedConverter: PusherEventConverter = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' &&
    (pusherEventData.name === 'powtoon_created' ||
      (pusherEventData.name === 'powtoon-events' && pusherEventData.data?.type === 'powtoon_created'))) {
    return createPowtoonCreatedEvent(pusherEventData.data)
  }
}

export const PowtoonDeletedConverter: PusherEventConverter = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' &&
    (pusherEventData.name === 'powtoon_deleted' ||
      (pusherEventData.name === 'powtoon-events' && pusherEventData.data?.type === 'powtoon_deleted'))) {
    return createPowtoonDeletedEvent(pusherEventData.data)
  }
}

export const ServerNotificationConverter: PusherEventConverter = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'message') {
    return createServerNotificationEvent(pusherEventData.message)
  }
}

export const PublishCompletedConverter: PusherEventConverter = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' &&
    pusherEventData.name === 'powtoon-events' &&
    pusherEventData.data?.type === 'publish_completed' && !pusherEventData.data.error) {
    return createPublishCompletedEvent(pusherEventData.data)
  }
}
export const PublishFailedConverter: PusherEventConverter = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' &&
    pusherEventData.name === 'powtoon-events' &&
    pusherEventData.data?.type === 'publish_completed' && pusherEventData.data.error) {
    return createPublishFailedEvent(pusherEventData.data)
  }
}

export const ConsumedExportConvertor = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' &&
    pusherEventData.name === 'consumed_export') {
    return createConsumedExportEvent(pusherEventData.data)
  }
}

export const LicenseUpdatedConverter = (
  createStandardPowtoonEventsConverter(createLicenseUpdatedEvent, 'license_updated')
)

export const BalanceUpdatedConverter = createStandardPowtoonEventsConverter(
  createBalanceUpdatedEvent,
  'balance_updated'
)

export const PPTXReadyConverter = createStandardPowtoonEventsConverter(createPPTXReadyEvent, 'pptx_powtoon_ready')

export const PPTXFailedConverter = createStandardPowtoonEventsConverter(createPPTXFailedEvent, 'pptx_failed')

export const FolderConvertor = createStandardPowtoonEventsConverter(folderEvent, 'folder_changed')

export const FolderItemsConvertor = createStandardPowtoonEventsConverter(
  folderItemsChangedEvent, 'folder_items_changed'
)

export const PowtoonContentVideoUrlUpdatedConverter: PusherEventConverter =
  (pusherEventName: string, pusherEventData: any) => {
    if (pusherEventName === 'server_event' &&
      (pusherEventData.name === 'powtoon_updated' ||
        (pusherEventData.name === 'powtoon-events' && pusherEventData.data?.type === 'powtoon_updated')) &&
      pusherEventData?.data?.content?.video_url !== undefined) {
      return createContentVideoUrlCreatedEvent(pusherEventData.data)
    }
  }

export const PowtoonRecordingVideoUpdatedConverter: PusherEventConverter =
  (pusherEventName: string, pusherEventData: any) => {
    if (pusherEventName === 'server_event' &&
      (pusherEventData.name === 'powtoon_updated' ||
        (pusherEventData.name === 'powtoon-events' && pusherEventData.data?.type === 'powtoon_updated')) &&
      pusherEventData?.data?.video_url !== undefined) {
      return createPowtoonRecordingVideoEventUpdatedEvent(pusherEventData.data)
    }
  }

export const PowtoonUpdatedConverter: PusherEventConverter = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' &&
    (pusherEventData.name === 'powtoon_updated' ||
      (pusherEventData.name === 'powtoon-events' && pusherEventData.data?.type === 'powtoon_updated'))) {
    return createPowtoonUpdatedEvent(pusherEventData.data)
  }
}

export const ClassChangedConverter: PusherEventConverter = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' &&
    pusherEventData.name === 'powtoon-events' && pusherEventData.data?.type === 'class_changed') {
    return createClassChangedEvent(pusherEventData.data)
  }
}
export const SubmissionChangedConverter: PusherEventConverter = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' &&
    pusherEventData.name === 'powtoon-events' && pusherEventData.data?.type === 'submission_changed') {
    return createSubmissionChangedEvent(pusherEventData.data)
  }
}

export const UserAssetUpdatedConverter: PusherEventConverter =
  (pusherEventName: string, pusherEventData: any) => {
    if (pusherEventName === 'server_event' &&
      pusherEventData?.data?.type === 'user_asset_updated') {
      return userAssetUpdatedEvent(pusherEventData.data)
    }
  }

export const PowtoonAccessConverter: PusherEventConverter = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' && pusherEventData.name === 'powtoon-events' &&
    (pusherEventData.data?.type === 'powtoon_access_granted' ||
      pusherEventData.data?.type === 'powtoon_access_revoked')
  ) {
    return createPowtoonAccessEvent(pusherEventData.data, pusherEventData.data?.type === 'powtoon_access_revoked')
  }
}

export const PowtoonAccessUpdatedConverter: PusherEventConverter = (pusherEventName: string, pusherEventData: any) => {
  if (pusherEventName === 'server_event' &&
    pusherEventData.name === 'powtoon-events' && pusherEventData.data?.type === 'powtoon_access_updated') {
    return createPowtoonAccessUpdated(pusherEventData.data)
  }
}

export const CompanyTemplateUpdatedConverter: PusherEventConverter =
  (pusherEventName: string, pusherEventData: any) => {
    if (pusherEventName === 'server_event' &&
      pusherEventData.name === 'powtoon-events' &&
      pusherEventData.data?.type === 'org_template_updated') {
      return createCompanyTemplateUpdatedEvent(pusherEventData.data)
    }
  }


export const PowtoonContentUpdatedEvent: PusherEventConverter =
  (pusherEventName: string, pusherEventData: any) => {
    if (pusherEventName === 'server_event' &&
      pusherEventData.name === 'powtoon-events' &&
      pusherEventData.data?.type === 'powtoon_content_updated') {
      return createPowtoonContentUpdatedEvent(pusherEventData.data)
    }
  }

export const SessionExpiredConverter: PusherEventConverter =
  (pusherEventName: string, pusherEventData: any) => {
    if (pusherEventName === 'server_event' &&
      pusherEventData.name === 'session-expired') {
      return createSessionExpiredEvent()
    }
  }
